// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3148fa27","457":"bacf999e","851":"791f54e1"}[chunkId] + ".chunk.js";
};